import React from 'react';
import ServicesFull from '../components/ServicesFull';

const ServicesPage = () => {
  return (
    <>
      <ServicesFull />
    </>
  );
};

export default ServicesPage;
